import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import {NativeAudio} from '@capacitor-community/native-audio'

interface Sound {
  key: string;
  asset: string;
  isNative: boolean
}

@Injectable({
  providedIn: 'root'
})
export class AudioService {

  private sounds: Sound[] = [];
  private audioPlayer: HTMLAudioElement = new Audio();
  private forceWebAudio = true;

  constructor(private platform: Platform){
    this.forceWebAudio = !(this.platform.is("ios") || this.platform.is("android"));
  }

  preload(key: string, asset: string): void {
    if(this.platform.is('cordova') && !this.forceWebAudio){

     // key, asset, 1, 1, 0
      NativeAudio.preload({
        assetId: key,
        assetPath: asset,
        audioChannelNum: 1,
        isUrl: false,
        volume: 1
      }).then(() => {
        
      }).catch((err) => {
        alert("Audio preload not work:"+" "+key+JSON.stringify(err));
        console.log(err);
      });

      this.sounds.push({
        key: key,
        asset: asset,
        isNative: true
      });

    } else {

      const audio = new Audio();
      audio.src = "assets/sounds/"+asset;

      this.sounds.push({
        key: key,
        asset: "assets/sounds/"+asset,
        isNative: false
      });

    }

  }

  stop(key: string): void {

    const soundToPlay = this.sounds.find((sound) => {
      return sound.key === key;
    });

    if(soundToPlay.isNative){

      NativeAudio.stop({assetId:soundToPlay.key}).then((res) => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });

    } else {
      this.audioPlayer.pause();
    }

  }

  async loop(key: string) {

    const soundToPlay = this.sounds.find((sound) => {
      return sound.key === key;
    });

    console.log("############IS NATIVE###########");
    console.log(key);
    console.log(soundToPlay.isNative);

    if(soundToPlay.isNative){
      console.log("############Audio is Native###########");
      try{
        const res = await NativeAudio.loop({assetId:soundToPlay.key});
      } catch(err) {
        alert(JSON.stringify(err));
      }

      


    } else {

      this.audioPlayer.src = soundToPlay.asset;
      this.audioPlayer.loop = true;
      this.audioPlayer.play();

    }

  }

  play(key: string): void {

    const soundToPlay = this.sounds.find((sound) => {
      return sound.key === key;
    });

    if(soundToPlay.isNative){

      NativeAudio.play({assetId:soundToPlay.key, time:0}).then((res) => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });

    } else {

      this.audioPlayer.src = soundToPlay.asset;
      this.audioPlayer.loop = false;
      this.audioPlayer.play();

    }

  }

}